import * as store from "./storage";
import * as api from "./api";
import { connect } from "react-redux";
import * as reducer from "./reducer";
export { password } from "./account";

const SESSION_TIMEOUT_THRESHOLD = 300; // Will refresh the access token 5 minutes before it expires

let sessionTimeout = null;

const tokens = {
  access_token: null,
  refresh_token: null,
  expires_in: null,
};

export const user = {
  id: null,
  name: null,
  email: null,
  picture: null,
  roles: null,
  organisation: null,
  customerRef : null,
  customerName: null,
};

const setSessionTimeout = (duration) => {
  clearTimeout(sessionTimeout);
  sessionTimeout = setTimeout(
    refreshToken, // eslint-disable-line no-use-before-define
    (duration - SESSION_TIMEOUT_THRESHOLD) * 1000,
  );
};

const clearSession = () => {
  store.destroy("tokens");
  store.destroy("user");

  tokens.access_token = null;
  tokens.refresh_token = null;
  tokens.expires_in = null;
  clearTimeout(sessionTimeout);
};

const onRequestSuccess = (response) => {
  if (!response) throw "doesnt work";

  setToken(response);

  //store.dispatch(actionCreators.update({ tokens }));
  setSessionTimeout(tokens.expires_in);

  return "ok";
};

const onRequestFailed = (exception) => {
  clearSession();
  throw exception.error_description;
};

/**
 * Persistance des tokens
 * @param newToken
 */
export const setToken = (newToken) => {
  tokens.access_token = newToken.access_token;
  tokens.refresh_token = newToken.refresh_token;
  tokens.expires_in = newToken.expires_in;

  store.save("tokens", tokens);
};

/**
 * Récupération des tokens en local
 * @returns {{token: null, refresh_token: null, expires_in: null}}
 */
export const getToken = () => {
  //Si pas de token stoké dans la class, on tente de récupérer ceux en local storage

  if (!tokens.refresh_token) {
    let storedToken = store.get("tokens");

    if (storedToken && storedToken.access_token) {
      tokens.access_token = storedToken.access_token;
      tokens.refresh_token = storedToken.refresh_token;
      tokens.expires_in = storedToken.expires_in;
    }
  }

  return tokens;
};

export const getUser = () => {
  //Si pas de token stoké dans la class, on tente de récupérer ceux en local storage
  if (!user.id) {
    let storedUser = store.get("user");

    if (storedUser && storedUser.id) {
      user.id = storedUser.id;
      user.name = storedUser.name;
      user.email = storedUser.email;
      user.picture = storedUser.picture;
      user.roles = storedUser.roles;
      user.costumer = storedUser.costumer;
      user.costumers = storedUser.costumers;
      user.organisation = storedUser.organisation;
      user.sellerRef = storedUser.sellerRef;
      user.customerRef = storedUser.customerRef;
      user.customerName = storedUser.customerName;
    }
  }

  return user;
};

export const getMe = () => api.getMe();

export const saveMe = (data) => api.saveMe(data);

export const setOnlineUser = () =>
  api.getMe().then(function(data) {
    setUser(data);
  });

/**
 * Persistance du user
 * @param myUser
 */
export const setUser = (myUser) => {
  user.id = myUser.id;
  user.name = myUser.name;
  user.email = myUser.email;
  user.picture = myUser.picture;
  user.roles = myUser.roles;
  user.costumer = myUser.costumer;
  user.costumers = myUser.costumers;
  user.organisation = myUser.organisation;
  user.sellerRef = myUser.sellerRef;
  user.customerRef = myUser.customerRef;
  user.customerName = myUser.customerName;


  store.save("user", user);
};

export const authenticated = () => {
  if (!getToken().refresh_token) {
    if (getUser().id) {
      return Promise.reject("deconnected");
    } else {
      return Promise.reject("new_user");
    }
  }

  return Promise.resolve("connected");
};

export const testRole = (roleToTest, debug = false) => {
  if (!roleToTest) return true;

  let user = getUser();

  if (debug) if (!user) return false;
  if (!user.roles) return false;

  let test = user.roles.filter((role) => role == roleToTest);

  if (roleToTest === "ROLE_USER") return true;
  return test.length > 0 ? true : false;
};

/**
 * Mise à jour des tokens au chargement
 * @returns {*}
 */
export const refreshToken = () => {
  if (!getToken().refresh_token) {
    if (getUser().id) {
      return Promise.reject("deconnected");
    } else {
      return Promise.reject("new_user");
    }
  } else {
    return api
      .refresh(tokens.refresh_token)
      .then(onRequestSuccess)
      .catch(onRequestFailed);
  }
};

export const authenticate = (username, password) =>
  api
    .authenticate(username, password)
    .then(onRequestSuccess)
    .catch(onRequestFailed);

export const revoke = () => {
  return api
    .revoke(tokens)
    .then(() => {
      clearSession();
    })
    .catch(() => {});
};



// WEBPACK FOOTER //
// ./src/services/session/index.js